import { FC } from "react";
import { FraudGroupsPopup } from "./FraudGroupsPopup";
import { FraudRulePopup } from "./FraudRulePopup";
import { TestRulesPopup } from "./TestRules";

export const FraudPopupContainer: FC = () => (
	<>
		<FraudGroupsPopup />
		<FraudRulePopup />
		<TestRulesPopup />
	</>
);
